/**
 * @module hooks/useEngineSync
 * @summary Bridge engine events → Zustand UI store.
 * @description Subscribes once to the engine's coarse events and refreshes the
 *   matching store slice, so only the affected chrome re-renders. The canvas
 *   itself is painted by the engine's RAF loop, independent of React.
 */
import { useEffect } from 'react';
import { engine } from '../engine/CanvasEngine';
import { useUiStore } from '../state/uiStore';

export function useEngineSync(): void {
  useEffect(() => {
    const s = useUiStore.getState();
    // Prime all slices once.
    s.syncTool();
    s.syncView();
    s.syncHistory();
    s.syncSelection();
    s.syncStatus();

    const offs = [
      engine.on('tool', () => useUiStore.getState().syncTool()),
      engine.on('view', () => useUiStore.getState().syncView()),
      engine.on('history', () => useUiStore.getState().syncHistory()),
      engine.on('selection', () => {
        useUiStore.getState().syncSelection();
        useUiStore.getState().syncStatus();
      }),
      engine.on('doc', () => {
        useUiStore.getState().syncStatus();
        useUiStore.getState().syncHistory();
        useUiStore.getState().bumpDoc();
      }),
      // Custom symbols / categories loaded or synced — re-render the palette.
      engine.on('library', () => useUiStore.getState().bumpLibrary()),
      engine.on('status', () => useUiStore.getState().syncStatus()),
    ];
    return () => offs.forEach((off) => off());
  }, []);
}
